import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import '../../index.css'
import LandingPageModal from '../../components/Modal'
import IconAnimation from 'components/IconAnimation'
import { Link } from 'react-router'

const Section4 = () => {
  const [modalData, setModalData] = useState({ isOpen: false, type: '' })

  const handleModalOpen = (type) => setModalData({ isOpen: true, type })
  const handleModalClose = () => setModalData({ isOpen: false, type: '' })

  const fadeInUpVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.9 } },
  }

  return (
    <motion.section
      className="Section4 px-4  p-12 pb-20 flex justify-center items-center h-auto sm:px-10 lg:px-20 py-12 sm:py-20 bg-[#0b0b0b] text-white"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false }}
      variants={fadeInUpVariant}
    >
      <div className="Section4-container max-w-[1300px]  w-full flex justify-between flex-col md:flex-row items-center gap-8">
        {/* Left side - animated icons */}
        <motion.div
          className="icons flex-1 w-full flex justify-center md:justify-start"
          variants={fadeInUpVariant}
          transition={{ delay: 0.4, duration: 0.6 }}
        >
          <IconAnimation />
        </motion.div>

        {/* Right side - animated content */}
        <motion.div
          className=" flex-1  w-full  md:text-left"
          variants={fadeInUpVariant}
          transition={{ delay: 0.2 }}
        >
          <h2 className="roboto-header text-2xl sm:text-3xl text-wrap lg:text-4xl font-semibold mb-4 leading-snug w-full">
            Learn and Expand Your Knowledge in the Blockchain Ecosystem
          </h2>

          <p className="text-base sm:text-lg mb-6 max-w-md md:mx-0">
            From cryptocurrency basics to advanced DeFi strategies, find the perfect course and
            tutor for your goals.
          </p>
          <Link to="/student/register">
            <button
              onClick={() => handleModalOpen('student')}
              className="cta-button bg-[#f79009] text-white font-semibold py-3 px-8 rounded-lg hover:bg-[#db7f07] transition-all duration-300"
            >
              Become a Student
            </button>
          </Link>
        </motion.div>
      </div>

      {modalData.isOpen && <LandingPageModal onClose={handleModalClose} type={modalData.type} />}
    </motion.section>
  )
}

export default Section4
